export var LocationType;
(function (LocationType) {
    LocationType["NATION"] = "NATION";
    LocationType["BUNDESLAND"] = "BUNDESLAND";
    LocationType["REGION"] = "REGION";
    LocationType["KREIS"] = "KREIS";
    LocationType["STADT"] = "STADT";
    LocationType["GEMEINDE"] = "GEMEINDE";
    LocationType["STADTTEIL"] = "STADTTEIL";
    LocationType["UNBEKANNT"] = "UNBEKANNT";
})(LocationType || (LocationType = {}));
export var Target;
(function (Target) {
    Target["Blank"] = "_blank";
    Target["Self"] = "_self";
})(Target || (Target = {}));
export var TagType;
(function (TagType) {
    TagType["I"] = "i";
    TagType["U"] = "u";
    TagType["B"] = "b";
    TagType["Br"] = "br";
    TagType["Link"] = "link";
    TagType["Text"] = "text";
    TagType["Anchor"] = "anchor";
})(TagType || (TagType = {}));
export var NativeWidthTypes;
(function (NativeWidthTypes) {
    NativeWidthTypes["SIDE"] = "side";
    NativeWidthTypes["CONTENT"] = "content";
    NativeWidthTypes["FULL"] = "full";
})(NativeWidthTypes || (NativeWidthTypes = {}));
export var CellAlign;
(function (CellAlign) {
    CellAlign["CENTER"] = "center";
    CellAlign["LEFT"] = "left";
    CellAlign["RIGHT"] = "right";
})(CellAlign || (CellAlign = {}));
//# sourceMappingURL=pageStructure.js.map